<template>
  <Select :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">
    <SelectTrigger class="w-full">
      <SelectValue :placeholder="placeholder || 'Select an option'" />
    </SelectTrigger>
    <SelectContent>
      <SelectItem v-for="typeOption in types" :key="typeOption" :value="typeOption">
        {{ typeOption }}
      </SelectItem>
    </SelectContent>
  </Select>
</template>

<script setup lang="ts">
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

defineProps<{
  types: string[] // Accept array of strings
  modelValue: string
  placeholder?: string
}>()

defineEmits(['update:modelValue'])
</script>
